
export enum Feature {
    VULNERABILITY_ANALYSIS = "VULNERABILITY_ANALYSIS",
    SBOM = "SBOM",
    AI = "AI"
}

export function formatFeature(feature?: Feature) {
    switch (feature) {
        case Feature.VULNERABILITY_ANALYSIS:
            return "Vulnerability analysis";
        case Feature.SBOM:
            return "SBOM";
        case Feature.AI:
            return "AI";
    }
}
